module.exports = __webpack_public_path__ + "img/mb-view-2.e0719afd.svg";